import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faEnvelope } from "@fortawesome/free-solid-svg-icons";

function NotificationsSection({ darkMode, t }) {
  const [emailOn, setEmailOn] = useState(true);

  const toggle = (val) => {
    setEmailOn(val);
    // TODO: save to backend
  };

  return (
    <div className="profile-section">
      <div className="profile-section-header">
        <div className="profile-section-icon">
          <FontAwesomeIcon icon={faBell} />
        </div>
        <div>
          <h2 className="profile-section-title">{t("Notifications")}</h2>
          <p className="profile-section-desc">{t("Manage your notification preferences")}</p>
        </div>
      </div>

      <div className="profile-setting">
        <div className="profile-setting-left">
          <div className="profile-setting-icon">
            <FontAwesomeIcon icon={faEnvelope} />
          </div>
          <div className="profile-setting-info">
            <h4>{t("Email Notifications")}</h4>
            <p>{t("Receive updates about requests, allocations, and reports")}</p>
          </div>
        </div>
        <label className="profile-toggle">
          <input type="checkbox" checked={emailOn} onChange={(e) => toggle(e.target.checked)} />
          <span className="profile-toggle-track">
            <span className="profile-toggle-thumb" />
          </span>
        </label>
      </div>
    </div>
  );
}

export default NotificationsSection;
